import { IndividualRelationshipEnum, IndividualSexEnum } from './schema'

/**
 * Minimal default nullable shape of previous ivf fields - useful for
 * form values and resetting if previousIvf is false
 */
export const defaultPreviousIvfFields = () => ({
  previousIvfRounds: null,
  previousProcedures: [],
  haveAchievedIvfLiveBirthPreviously: null,
  previousIvfRoundResultingInLiveBirth: null,
  lastFreshEggsCollected: null,
  lastFreshEmbryosCreated: null,
  lastEmbryosTransferred: null,
  blastocystAge: null,
  lastTransferType: null,
  embryosStored: null,
  hasEmbryosStored: null,
})

/**
 * Minimal default nullable shape of treatment health input - useful for
 * form values
 */
export const defaultTreatmentHealthInput = ({
  hasPartner,
}: {
  hasPartner?: boolean
}) => ({
  roleMember: {
    relationship: IndividualRelationshipEnum.Self,
    sex: null,
    dateOfBirth: null,
    height: null,
    weight: null,
  },
  rolePartner: {
    sex: hasPartner === false ? IndividualSexEnum.Unknown : null,
    dateOfBirth: null,
    relationship:
      hasPartner === false
        ? IndividualRelationshipEnum.None
        : IndividualRelationshipEnum.Partner,
  },

  // diagnoses
  diagnoses: [],
  diagnosesDescription: null,

  // female fields
  haveAchievedLiveBirthPreviously: null,
  hasBeenPregnant: null,
  previousPregnanciesCount: null,
  previousLiveBirthsCount: null,
  knowsAmh: null,
  roleEggProvider: {
    sex: IndividualSexEnum.Female,
    dateOfBirth: null,
    amh: null,
    relationship: null,
  },
})

/**
 * Minimal default nullable shape of treatment journey input - useful
 * for form values What is required to be added to health input to
 * create wholeProfile
 */
export const defaultTreatmentJourneyInput = () => ({
  // previous ivf fields
  previousIvf: null,
  ...defaultPreviousIvfFields(),

  // future ivf fields
  previousConsultations: [],
  roleSpermProvider: {
    sex: IndividualSexEnum.Male,
    relationship: null,
  },
  roleEmbryoCarrier: {
    sex: IndividualSexEnum.Female,
    relationship: null,
  },
  explicitProcedures: [],
  eggsStored: null,
  numEggsStored: null,
  eggsStoredAge: null,
  extraInformationFromUser: null,
})

/**
 * Minimal default nullable shape of treatment whole profile input -
 * useful for form values on update page
 */
export const defaultTreatmentWholeProfileInput = () => ({
  ...defaultTreatmentHealthInput({}),
  ...defaultTreatmentJourneyInput(),
})
